const coccidiostatos = [
  'Clopidol',
  'Decoquinato',
  'Diclazuril',
  'Lasalosid',
  'Maduramicina',
  'Monensina',
  'Narasina',
  'Nicabacina',
  'Nicarbacina + Maduramicna',
  'Nicarbacina + Monensina',
  'Nicarbacina + Narasina',
  'Nicarbacina + Salinomicina',
  'Robenidina',
  'Salinomicina',
  'Semduramicina',
  'Vacuna',
  'Ninguno',
  'No Informa',
  'Otro'
];

const promotoresDeCrecimiento = [
  'Aceites Esenciales',
  'Acidos Organicos',
  'Avilamicina',
  'Bacitracina',
  'Bambermicina',
  'BMD',
  'Clortetraciclina',
  'Enramicina',
  'Fitobiotico',
  'Fitobiotico + Probiotico',
  'Fitobiotico + Prebiotico',
  'Flavomicina',
  'Leucomicina',
  'Lincomicina',
  'Lincomicina + Estreptomicina',
  'Neomicina',
  'Oxitetramicna',
  'Prebiotico + Probiotico',
  'Probiotico',
  'Tilosina',
  'Virginamicina',
  'Ninguno',
  'No Informa',
  'Otro'
]


const productos = {
  coccidiostatos: coccidiostatos,
  promotoresDeCrecimiento: promotoresDeCrecimiento
}

export default productos
